var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgVerified = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.333 8.327-1.626-1.86.226-2.46-2.406-.547-1.26-2.127L8 2.307l-2.267-.974-1.26 2.127L2.067 4l.226 2.467-1.626 1.86 1.626 1.86-.226 2.466 2.406.547 1.26 2.133L8 14.353l2.267.974 1.26-2.127 2.406-.547-.226-2.46 1.626-1.866Zm-2.633.986-.373.434.053.566.12 1.3-1.827.414-.293.493-.66 1.12-1.187-.513L8 12.9l-.527.227-1.186.513-.66-1.113-.294-.494-1.826-.413.12-1.307.053-.566-.373-.434-.86-.98.86-.986.373-.434-.06-.573-.12-1.293 1.827-.414.293-.493.66-1.12 1.187.513L8 3.76l.527-.227 1.186-.513.66 1.12.294.493 1.826.414-.12 1.3-.053.566.373.434.86.98-.853.986Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.727 9.5 5.18 7.947l-.987.993 2.534 2.54 4.893-4.907-.987-.993L6.727 9.5Z",
  fill: "currentColor"
})));

export default SvgVerified;